import { Route, Switch } from 'react-router-dom'

import Error404 from '../ui/views/errors/Error404'
import Home from '../App/Home'
import ShippingSend from '../context/ShippingSend'
import ShippingsTracking from '../App/ShippingsTracking'
import Help from '../context/Help'
import PrintSettings from '../App/PrintSettings'
import Downloads from '../context/DownloadInstallJSPMApp'
import Billing from '../App/Billing'
import UserZone from '../App/UserZone'

import * as routes from '../routes'
import ShippingDetail from '../context/ShippingDetail'
import ShippingsRecording from '../App/ShippingsRecording'
import Agenda from '../App/Agenda'
import Reports from '../App/Reports'
import ProtectedRoute from './ProtectedRoute'

const DesktopRouter = () => {
  return (
    <Switch>
      <Route exact path={routes.HOME.path}>
        <Home />
      </Route>

      <Route exact path={routes.SHIPPING_SEND.path}>
        <ShippingSend />
      </Route>

      <Route exact path={routes.SHIPPING_DETAIL.path}>
        <ShippingDetail />
      </Route>

      <Route exact path={routes.SHIPPINGS_TRACKING.path}>
        <ShippingsTracking />
      </Route>

      <ProtectedRoute
        exact
        path={routes.SHIPPINGS_RECORDING.path}
        component={ShippingsRecording}
        allowedUserCodes={['40574', '40236', '40193', '90132']}
      />

      <Route exact path={routes.HELP.path}>
        <Help />
      </Route>

      <Route exact path={routes.PRINT_SETTINGS.path}>
        <PrintSettings />
      </Route>

      <Route exact path={routes.DOWNLOADS.path}>
        <Downloads />
      </Route>

      <Route exact path={routes.BILLING.path}>
        <Billing />
      </Route>

      <Route exact path={routes.USER_ZONE.path}>
        <UserZone />
      </Route>

      <Route exact path={routes.AGENDA.path}>
        <Agenda />
      </Route>

      {/* <Route exact path={routes.REPORTS.path}>
        <Reports />
      </Route> */}

      <Route component={Error404} />
    </Switch>
  )
}

export default DesktopRouter
